import { ActionIcon, CopyButton, Group, Text, Tooltip } from "@mantine/core";
import { IconCheck, IconCopy } from "@tabler/icons-react";

type Props = {
  value?: string | null;
  size?: "xs" | "sm";
};

// For SnappPay bookings the backend stores the SnappPay transaction id as the rrn,
// so this is the number the "شناسه اسنپ‌پی" filter searches.
export default function PaymentReference({ value, size = "sm" }: Props) {
  if (!value) return <Text size={size} c="dimmed">—</Text>;

  return (
    <Group gap={4} wrap="nowrap" justify="center">
      <Text size={size} fw={600} dir="ltr" style={{ fontVariantNumeric: "tabular-nums" }}>
        {value}
      </Text>
      <CopyButton value={value} timeout={1500}>
        {({ copied, copy }) => (
          <Tooltip label={copied ? "کپی شد" : "کپی شماره پیگیری"} withArrow>
            <ActionIcon
              size="sm"
              variant="subtle"
              color={copied ? "teal" : "gray"}
              aria-label="کپی شماره پیگیری"
              onClick={(event) => {
                event.stopPropagation();
                copy();
              }}
            >
              {copied ? <IconCheck size={14} /> : <IconCopy size={14} />}
            </ActionIcon>
          </Tooltip>
        )}
      </CopyButton>
    </Group>
  );
}
